import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {IWarehouse} from "../interfaces/Warehouse";

interface WarehouseState {
    value: {
        defaultWarehouse: number | null,
        warehousesList: IWarehouse[]
    }
}

const initialState: WarehouseState = {
    value: {
        defaultWarehouse: 0,
        warehousesList: []
    }
};

export const warehouseSlise = createSlice({
        name: 'rate',
        initialState,
        reducers: {
            setWarehouse: (state, action: PayloadAction<number>) => {
                state.value.defaultWarehouse = action.payload
            },
            setWarehousesList: (state, action: PayloadAction<IWarehouse[]>) => {
                state.value.warehousesList = action.payload
            }
        }
    }
);

export const { setWarehouse, setWarehousesList } = warehouseSlise.actions

export default warehouseSlise.reducer